import React from 'react';

export default function ScoreTable() {
  return (
    <div className="w-full text-[20px] md:text-[32px] font-bold">
      {/* Header Row */}
      <div className="w-full md:w-[527px] h-[0px] md:h-[85px] flex items-center text-[10px] md:text-[30px] font-bold">
        Scores
      </div>

      <div className="flex justify-end -mb-5 text-[8px] md:text-[24px]">
        <div className="w-[120px] md:w-[527px] h-[40px] md:h-[85px] flex items-center"></div>
        <div className="flex-1 h-[40px] md:h-[85px] flex items-center font-light">Target score</div>
        <div className="flex-1 h-[40px] md:h-[85px] flex items-center font-light">Candidate score</div>
      </div>

      {/* Data Rows */}
      {[
        ['Enterpreneurship', '6.1', '5.2'],
        ['Production', '6.1', '5.2'],
        ['Financial management', '6.1', '5.2'],
        ['-', '-', '-'],
        ['-', '-', '-'],
        ['-', '-', '-'],
        ['-', '-', '-'],
        ['-', '-', '-'],
        ['Average score', '6.1', '5.2'],
      ].map((row, index) => (
        <div
          key={index}
          className={`flex ${index === 8 ? 'mt-8 md:mt-14' : 'mb-2 md:mb-3'} text-[6px] md:text-[24px]`}
        >
          <div className="w-[120px] md:w-[527px] h-[40px] md:h-[85px] flex items-center pl-2 md:pl-6 bg-[#FAFBFB]">
            {row[0]}
          </div>
          <div className="flex-1 h-[40px] md:h-[85px] flex items-center justify-center bg-[#F3F5F5]">
            {row[1]}
          </div>
          <div className="flex-1 h-[40px] md:h-[85px] flex items-center justify-center bg-[#EDF0EF]">
            {row[2]}
          </div>
        </div>
      ))}
    </div>
  );
}
